"use client";
import SelectInput from "@components/common/SelectInput";
import { useIsMobile } from "@components/mediaQuery/useIsMobile";

const ActivationTypeComponent = ({ formData, setFormData, errors, marginTop }) => {
	const handleAccountNumber = (id, value, name) => {
		setFormData(value);
	};
	const isMobile = useIsMobile();

	return (
		<SelectInput
			id="activation-type"
			dataTestId="activation-type-select"
			label="Type *"
			placeholder="Select Type"
			value={formData.type}
			onChange={handleAccountNumber}
			options={[
				{ id: "LAND", name: "LOCAL", value: "LAND" },
				{ id: "MOBILE", name: "GLOBAL", value: "MOBILE" },
			]}
			displayField="name"
			marginTop={marginTop}
			classDropdown={`${isMobile ? "absolute z-20" : "absolute z-40"}`}
		/>
	);
};

export default ActivationTypeComponent;
